// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--AlvNs","icon":"_6c97079b1b--icon--bylAh","text":"_6c97079b1b--text--leNZw"};